import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import TenantsList from './pages/Tenants/TenantsList';
import SucursalesList from './pages/Sucursales/SucursalesList';
import CajasList from './pages/Cajas/CajasList';
import UsersList from './pages/Users/UsersList';
import ProductosList from './pages/Productos/ProductosList';
import CategoriasList from './pages/Categorias/CategoriasList';
import InventarioList from './pages/Inventario/InventarioList';
import MovimientosList from './pages/Inventario/MovimientosList';
import TransferenciasList from './pages/Transferencias/TransferenciasList';
import SesionesCajaList from './pages/SesionesCaja/SesionesCajaList';
import PuntoVenta from './pages/POS/PuntoVenta';
import ReportesDashboard from './pages/Reportes/ReportesDashboard';
import ReporteVentas from './pages/Reportes/ReporteVentas';
import ClientesList from './pages/Clientes/ClientesList';
import ListasPreciosList from './pages/ListasPrecios/ListasPreciosList';
import VariantesList from './pages/Variantes/VariantesList';
import ImpuestosList from './pages/Impuestos/ImpuestosList';
import ReglasPropinasList from './pages/ReglasPropinas/ReglasPropinasList';
import ConteosFisicosList from './pages/ConteosFisicos/ConteosFisicosList';
import ConteoFisicoDetail from './pages/ConteosFisicos/ConteoFisicoDetail';
import OrdenesList from './pages/Ordenes/OrdenesList';
import PaquetesList from './pages/Paquetes/PaquetesList';
import PaqueteEntrada from './pages/Paquetes/PaqueteEntrada';
import PaqueteSalida from './pages/Paquetes/PaqueteSalida';
import PaqueteDashboard from './pages/Paquetes/PaqueteDashboard';
import CRMDashboard from './pages/CRM/CRMDashboard';
import LeadsList from './pages/CRM/LeadsList';
import LeadDetail from './pages/CRM/LeadDetail';
import LeadForm from './pages/CRM/LeadForm';
import OportunidadesPipeline from './pages/CRM/OportunidadesPipeline';
import OportunidadForm from './pages/CRM/OportunidadForm';
import ActividadForm from './pages/CRM/ActividadForm';
import MiTrabajo from './pages/CRM/MiTrabajo';
import TiendaHome from './pages/Tienda/TiendaHome';
import Layout from './components/Layout/Layout';
import PrivateRoute from './components/Auth/PrivateRoute';

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="tenants" element={<TenantsList />} />
        <Route path="sucursales" element={<SucursalesList />} />
        <Route path="cajas" element={<CajasList />} />
        <Route path="usuarios" element={<UsersList />} />
        <Route path="productos" element={<ProductosList />} />
        <Route path="categorias" element={<CategoriasList />} />
        <Route path="inventario" element={<InventarioList />} />
        <Route path="inventario/movimientos" element={<MovimientosList />} />
        <Route path="transferencias" element={<TransferenciasList />} />
        <Route path="sesiones-caja" element={<SesionesCajaList />} />
        <Route path="pos" element={<PuntoVenta />} />
        <Route path="reportes" element={<ReportesDashboard />} />
        <Route path="reportes/ventas" element={<ReporteVentas />} />
        <Route path="clientes" element={<ClientesList />} />
        <Route path="listas-precios" element={<ListasPreciosList />} />
        <Route path="variantes" element={<VariantesList />} />
        <Route path="impuestos" element={<ImpuestosList />} />
        <Route path="reglas-propinas" element={<ReglasPropinasList />} />
        <Route path="conteos-fisicos" element={<ConteosFisicosList />} />
        <Route path="conteos-fisicos/:id" element={<ConteoFisicoDetail />} />
        <Route path="ordenes" element={<OrdenesList />} />
        <Route path="paquetes" element={<PaquetesList />} />
        <Route path="paquetes/entrada" element={<PaqueteEntrada />} />
        <Route path="paquetes/salida" element={<PaqueteSalida />} />
        <Route path="paquetes/dashboard" element={<PaqueteDashboard />} />
        <Route path="crm" element={<CRMDashboard />} />
        <Route path="crm/trabajo" element={<MiTrabajo />} />
        <Route path="crm/leads" element={<LeadsList />} />
        <Route path="crm/leads/nuevo" element={<LeadForm />} />
        <Route path="crm/leads/:id" element={<LeadDetail />} />
        <Route path="crm/leads/:id/editar" element={<LeadForm />} />
        <Route path="crm/oportunidades" element={<OportunidadesPipeline />} />
        <Route path="crm/oportunidades/nueva" element={<OportunidadForm />} />
        <Route path="crm/oportunidades/:id" element={<OportunidadForm />} />
        <Route path="crm/actividades/nueva" element={<ActividadForm />} />
        <Route path="tienda" element={<TiendaHome />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}

export default App;

